<template>
	<div class="text-right p-4" v-if="productModel">
		<ty-row :gutter="10">
			<ty-col :xs="24" :sm="6" :md="8" :lg="6" :xl="6">
				<ty-select disabled v-if="categories!==null" v-model="productModel.category_id">
					<ty-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id" />
				</ty-select>
			</ty-col>
			<ty-col :xs="24" :sm="18" :md="14" :lg="18" :xl="18">
				<p class="mt-0 ty-color-dark-gray fw-200 fs-14">
					در این قسمت ویژگی های محصول را می‌توانید اضافه کنید و آن ها را در دسته بندی انتخاب شده ذخیره کنید تا
					دفعات بعد تمامی ویژگی های ذخیره شده در دسترس باشند.
				</p>
			</ty-col>
		</ty-row>
		<div class="mt-4 ty-flex">
			<div class="fw-400" style="min-width: 120px">افزودن ویژگی ها</div>
			<div class="ty-border-bottom ty-color-dark my-auto" style="width: 100%;height:1px" />
		</div>
		<div v-loading="loading_features" v-if="productModel" class="mt-4"
			style="min-height: 200px; overflow-y: auto">
			<div v-for="item in groups" :key="item.id" class="mt-3">
				<div>
					<span class="fw-500 fs-12">{{item.name}}</span>
					<feature-list :product-id="productModel.id" :category="productModel.category" :group-id="item.id"
						v-model="features" />
				</div>
			</div>
			<div class="mt-3">
				<span class="fw-500 fs-12">متفرقه</span>
				<feature-list :product-id="productModel.id" :category="productModel.category" :group-id="null"
					v-model="features" />
			</div>
		</div>
		<div class="ty-flex mt-4">
			<ty-button @click="update()" color="success" class="mr-auto" size="medium">ذخیره محصول</ty-button>
		</div>
	</div>
</template>

<script>
	// import {
	// 	Cirus
	// } from '@/classes/Http';
	import {
		Instance
	} from '@/classes/TayehApi';
	import Features from '../productFeature/List';
	export default {
		props: {
			product: {
				type: Object,
				default: null
			},
			instanceId: {
				type: [Number, String],
				required: true
			}
		},
		components: {
			'feature-list': Features
		},
		data() {
			const {
				product
			} = this;
			return {
				productModel: product,
				features: product.features.filter(feature => {
					return ((!(feature.type in ['select', 'rate']))&&(product.category.filters.findIndex(((filter) => filter.id===feature.filter_id))!==-1))
				})??[],
				categories: null,
				groups: [],
				loading_features: false
			}
		},
		methods: {
			hasThisGroup(group_id) {
				return typeof this.features.find((feature) => {
					return feature.group_id == group_id
				}) !== 'undefined'
			},
			async update() {
				this.loading_features = true;
				await Instance.updateProductFeatures(this.instanceId, this.product.id, this.features.filter(feature => feature.filter).map(
					feature => {
						return {
							value: feature.value,
							filter_id: feature.filter.id,
							category_id: feature.filter.category_id,
							feature_id: feature.id,
							type: feature.type
						}
				}))

				this.loading_features = false;
				// try {
				// 	let res = await Cirus.post(
				// 		`/instance/${this.instanceId}/product`,
				// 		this.product
				// 	)
				// 	if (res.data.err) {
				// 		this.$message({
				// 			showClose: true,
				// 			message: res.data.err,
				// 			type: 'error',
				// 			duration: 5000
				// 		});
				// 	} else {
				// 		this.$message({
				// 			showClose: true,
				// 			message: 'محصول ذخیره شد.',
				// 			type: 'success',
				// 			duration: 5000
				// 		});
				// 	}
				// } catch {
				// 	this.$message({
				// 		showClose: true,
				// 		message: 'لطفا دوباره تلاش کنید.',
				// 		type: 'error',
				// 		duration: 5000
				// 	});
				// } finally {
				// 	this.$emit('updated')
				// }
			},
			async getCategories() {
				try {
					this.categories = (await Instance.getCategoriesWithFilter(this.instanceId)).data.objects;
				} catch (err) {
					console.log(err);
				}
			},
			async getGroups() {
				if (!this.product.category_id) return
				const res = await Instance.getCategoryFilterGroup(this.instanceId, this.product.category_id)
				this.groups = res.data;
			},
		},
		mounted() {
			this.getCategories();
			this.getGroups();
		}
	}
</script>